import React, { useState, useCallback } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import { isLoggedIn, logout } from "./Auth/auth";
import { PrivateRoute } from "./Auth/PrivateRoute";
import { OrganisationDetail } from "./OrganisationDetail";
import { LoginForm } from "./Login/LoginForm";
import { CreateAccount } from "./Login/CreateAccount";
import { EpreuveBoard } from "./EpreuveBoard";
import { EpreuveDetail } from "./EpreuveDetail";
import { EpreuveForm } from "./Edition/EpreuveForm";
import { EventUpdate } from "./Edition/EventUpdate";
import { Navbar } from "./Components/Navbar";
import { Footer } from "./Components/Footer";
import { AccountSpace } from "./members/AccountSpace";
import { Discover } from "./calendarpage/Discover";
import { Performance } from "./calendarpage/Performance";
import { Dompter } from "./calendarpage/Dompter";
import { Nature } from "./calendarpage/Nature";
import { ArticlePage } from "./Article/ArticlePage";
import "./styles/main.scss";

// Référence stable (pas de tableau recréé à chaque rendu tant qu'il n'y a
// pas de vrai panier connecté à cette page)
const EMPTY_BASKET = [];

// Composant interne : useHistory nécessite d'être rendu à l'intérieur de <Router>,
// donc la logique de login/logout vit ici plutôt que dans App directement.
const AppShell = () => {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const history = useHistory();

  const handleLogin = useCallback(() => {
    setLoggedIn(true);
    history.push("/epreuves/new");
  }, [history]);

  const handleLogout = useCallback(() => {
    logout();
    setLoggedIn(false);
    history.push("/");
  }, [history]);

  return (
    // .app-shell = colonne flex pleine hauteur (voir layout.scss) :
    // permet au footer de rester en bas même sur une page courte,
    // au lieu de "flotter" juste après un contenu trop petit.
    <div className="app-shell">
      {/* Navbar est en fixed-top : elle n'a pas besoin (et ne bénéficie
          pas) d'un wrapper avec une marge — un élément fixed est sorti
          du flux, donc ce mb-5 ne compensait rien de réel. */}
      <Navbar
        loggedIn={loggedIn}
        onLogout={handleLogout}
        basketItems={EMPTY_BASKET}
      />
      {/* .app-content apporte le padding-top qui compense la hauteur
          réelle de la navbar fixe (variable --navbar-height dans
          layout.scss), au lieu des mt-5/mt-4 approximatifs et
          incohérents dispersés dans chaque page. */}
      <main className="main-content app-content">
        <div className="mx-0 row">
          <div className="container visible-md">
            <Switch>
              <Route exact path="/" component={EpreuveBoard} />
              <Route exact path="/triathlon/decouverte" component={Discover} />
              <Route
                exact
                path="/triathlon/performance"
                component={Performance}
              />
              <Route exact path="/triathlon/dompter" component={Dompter} />
              <Route exact path="/triathlon/nature" component={Nature} />

              <Route
                path="/organisations/:organisationId"
                component={OrganisationDetail}
              />
              <PrivateRoute
                exact
                path="/epreuves/new"
                component={EpreuveForm}
              />
              <PrivateRoute
                exact
                path="/epreuves/update"
                component={EventUpdate}
              />
              <PrivateRoute
                exact
                path="/epreuves/compte"
                component={AccountSpace}
              />
              <Route
                exact
                path="/articles/bien-choisir-son-format"
                component={ArticlePage}
              />
              <Route
                path="/epreuve/:epreuveId"
                render={(routeProps) => (
                  <EpreuveDetail
                    {...routeProps}
                    key={routeProps.match.params.epreuveId}
                  />
                )}
              />
              <Route
                exact
                path="/compte/creer-compte"
                component={CreateAccount}
              />
              <Route
                exact
                path="/login"
                render={() => <LoginForm onLogin={handleLogin} />}
              />
              <Route
                render={() => (
                  <div className="container py-5 text-center">
                    <h1>Page introuvable</h1>
                    <p className="text-muted">
                      Le contenu demandé n'existe pas ou plus.
                    </p>
                  </div>
                )}
              />
            </Switch>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const App = () => (
  <Router>
    <AppShell />
  </Router>
);
